<template>
  <div>
    <mtd-table
      v-if="list&&list.length"
      :data="list"
      bordered
      striped
    >
      <mtd-table-column
        v-for="item in columns"
        :key="item.label"
        v-bind="item"
        align="center"
      />
    </mtd-table>
    <NoBillTips
      v-else
      msg="暂无数据"
    />
  </div>
</template>
<script>
import { mapState } from 'vuex';
import NoBillTips from '@/components/NoBillTips';
import BillApi from '@/api/bill';
import { formatAmount, formatTableColumns } from '@/util/filter';
import STATUS from '@/constants/status';

export default {
  name: 'Cashback',
  components: { NoBillTips },
  data() {
    return {
      list: [],
      columns: formatTableColumns([
        {
          label: '合作商',
          prop: 'partnerName',
        },
        {
          label: '交易月份',
          prop: 'billMonth',
        },
        {
          label: '返点基数',
          formatter: (row) => formatAmount(row.baseAmount),
        },
        {
          label: '返点比例',
          formatter: (row) => `${row.rebateRate}%`,
        },
        {
          label: '返点金额',
          formatter: (row) => formatAmount(row.rebateAmount),
        },
      ]),
    };
  },
  computed: {
    ...mapState('billModule', {
      billInfo(state) {
        return state.currentBilledInfo;
      },
    }),
  },
  created() {
    this.getData();
  },
  methods: {
    formatAmount,
    async getData() {
      const { cutMonth: billMonth, customerId } = this.billInfo;
      const params = {
        customerId,
        billMonth,
      };
      const { code, data } = await BillApi.getCashbackBill(params);
      if (code === STATUS.SUCCESS) {
        this.list = data || [];
      }
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep .mtd-table-cell {
  padding-left: 6px;
  padding-right: 6px;
}
</style>
